export default function getFileNameFromContentDisposition(disposition) {
  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/ // 正規表現でfilenameを抜き出す
  const matches = filenameRegex.exec(disposition)
  if (matches != null && matches[1]) {
    const fileName = matches[1].replace(/['"]/g, '');
    return decodeURI(fileName) // 日本語対応
  } else {
    return null
  }
}